import React, { useState } from "react";
import InspectorForm from "./InspectorForm";
import { formatPhoneNumber } from "../../../utils/helpers";

function EditInspector({ onClose, data }) {
  const [formData, setFormData] = useState({
    email: data.user.email,
    // password: data.user.password,
    name: data.user.name,
    phone_number: formatPhoneNumber(data.user.phone_number),
    company_name: data.company_name || "",
    company_license: data.company_license || "",
    company_license_expiry_date: data.company_license_expiry_date || "",
    company_address: data.company_address || "",
    company_phone: formatPhoneNumber(data.company_phone) || "",
    company_email: data.company_email || "",
    company_license_attachment_file_name:
      data.company_license_attachment_file_name || "",
      company_license_attachment: data.company_license_attachment || "",
    certificate_id: data.certificate_id,
    certification_expire_date: data.certification_expire_date,
    has_permission: data.has_permission,
    xrf_devices: data.xrf_devices,
    id: data.inspector_id,
    file_name: data.file_name,
  });
  return (
    <div>
      <InspectorForm initialValues={formData} onClose={onClose} isEdit={true} />
    </div>
  );
}

export default EditInspector;
